/**
 * External URLs used across the MCP consent flow.
 * All values are sourced from envConfig.mcpPolicy so they can vary per environment.
 */

import { getConfig } from '../../../config/envConfig';

const { mcpPolicy } = getConfig();

/** Documentation page explaining the Rovo MCP Server. */
export const MCP_ROVO_DOC_URL = mcpPolicy.rovoDocUrl;

/** Developer docs — OAuth 2.0 3LO apps (used as the "Learn more" link in McpInfoCard and migration guide). */
export const MCP_DEVELOPER_DOC_URL = mcpPolicy.developerDocUrl;

/** Trello MCP docs — used as the "Learn more" link in McpInfoCard when Trello scopes are present. */
export const MCP_TRELLO_DOC_URL =
  'https://support.atlassian.com/trello/docs/connect-trello-to-ai-assistants-with-trello-mcp/';

/** Trello support — used as the support link in Trello-only flows. */
export const MCP_TRELLO_SUPPORT_URL = 'https://support.atlassian.com/trello';

/** SSE migration guide URL. */
export const MCP_SSE_MIGRATION_GUIDE_URL = mcpPolicy.sseMigrationGuideUrl;

/** Admin guide for managing MCP permission policies (used in McpPermissions empty state and McpPolicyAlerts). */
export const MCP_PERMISSIONS_MANAGEMENT_DOC_URL = mcpPolicy.permissionsManagementDocUrl;

/** The deprecated SSE endpoint — shown inline in the SSE deprecation banner. */
export const MCP_DEPRECATED_SSE_ENDPOINT = mcpPolicy.deprecatedSseEndpoint;

// Shared URLs (privacy policy, terms of use) live in ../shared/agent-consent/urls.ts.
